<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{translate.instant("APPPILOTAGE.TITRE")}}</span>
    <form [formGroup]="formOptions">
        <div class="row">
            <div class="col-md-12">
                <select-gala [label]="lgTrad.ACTIONS" formControlName="ACTION" [options]="listeOptions"
                    bindLabel="LABEL" bindValue="ID" [placeholder]="lgTrad.ACTIONS" />
            </div>
        </div>
    </form>
    <div gala-dialog-actions>
        <button mat-stroked-button color="primary" (click)="lancerAction()">{{translate.instant("VAL")}}</button>
    </div>
</dialog-gala>